/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-01 18:26:49
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-01-04 18:15:00
 * @FilePath: \sns-user-frontend\src\service\index.js
 * @Description: 
 */
import UGC from './ugc'
import FRONTEND from './frontend'
import USER from './user'
import CIRCLE from './circle'
import MSG from './msg'
import CHAT from './chat'
import TASK from './task'
import TOPIC from './topic'
import CONTEST from './contest'
import ACTIVITY from './activity'
import GALLERY from './gallery'
import POC from './poc'
import ANNUAL from './annual'
import Emoji from './emoji'
import operate from './operate'
import lifeStudio from './lifeStudio'
import authorize from './authorize'
import medalsApi from './medals'
import merchaindise from './merchaindise'
import shootOnOppo from './shootOnOppo'
import membershipApi from './memberShip'
import meetupApi from './meetup'

const api = {
  ...UGC,
  ...MSG,
  ...USER,
  ...CHAT,
  ...CIRCLE,
  ...FRONTEND,
  ...TASK,
  ...TOPIC,
  ...CONTEST,
  ...ACTIVITY,
  ...GALLERY,
  ...POC,
  ...ANNUAL,
  ...Emoji,
  operate,
  lifeStudio,
  authorize,
  medalsApi,
  merchaindise,
  shootOnOppo,
  membershipApi,
  meetupApi
}
export default api